import { useEffect } from "react";
import type { EntityPush } from "@/lib/meeting-reminders/entity-push";
import { FloatingActionCard } from "./floating-action-card";

const AUTO_DISMISS_MS = 30_000;

interface PushNotificationCardProps {
  push: EntityPush;
  onOpen: (push: EntityPush) => void;
  onDismiss: (tag: string) => void;
}

export function PushNotificationCard({ push, onOpen, onDismiss }: PushNotificationCardProps) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(push.tag), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [onDismiss, push]);

  return (
    <FloatingActionCard
      title={push.title}
      subtitle={push.body}
      onOpen={() => onOpen(push)}
      onDismiss={() => onDismiss(push.tag)}
    />
  );
}
